import { Role } from "../../helpers/role";

export const ServiceProviderRoutes = [
  {
    name: "DRS_ServiceProvider",
    path: `/${Role.ServiceProvider}`,
    redirect: "/",
    component: () => import("@/layouts/Layout"),
    children: [
      {
        name: "ServiceProvider_Home",
        path: "/",
        component: () => import("@/views/service-provider/Home"),
        meta: {
          authorize: [Role.ServiceProvider],
        },
      },

      {
        name: "ServiceProvider_DistributorList",
        path: "distributor-list",
        component: () => import("@/views/service-provider/DistributorList"),
        meta: {
          authorize: [Role.ServiceProvider],
        },
      },

      {
        name: "ServiceProvider_DistributorPendingApproval",
        path: "distributor-pending-approval",
        component: () =>
          import("@/views/service-provider/DistributorPendingApproval"),
        meta: {
          authorize: [Role.ServiceProvider],
        },
      },

      {
        name: "ServiceProvider_DistributorDenied",
        path: "distributor-denied",
        component: () => import("@/views/service-provider/DistributorDenied"),
        meta: {
          authorize: [Role.ServiceProvider],
        },
      },

      {
        name: "ServiceProvider_TopupPendingApproval",
        path: "topup-request-pending-approval",
        component: () =>
          import("@/views/service-provider/TopupPendingApproval"),
        meta: {
          authorize: [Role.ServiceProvider],
        },
      },

      {
        name: "ServiceProvider_TopupHistory",
        path: "topup-request-history",
        component: () =>
          import("@/views/service-provider/TopupHistory"),
        meta: {
          authorize: [Role.ServiceProvider],
        },
      },

      {
        name: "ServiceProvider_RevenueReport",
        path: "revenue-report",
        component: () =>
          import("@/views/service-provider/RevenueReport"),
        meta: {
          authorize: [Role.ServiceProvider],
        },
      },
      {
        name: "ServiceProvider_ListAccount",
        path: "accounts",
        component: () => import("@/views/service-provider/ServiceProviderListAccount"),
        meta: {
          authorize: [Role.ServiceProvider],
        },
      },
      {
        name: "ServiceProvider_CreateAccount",
        path: "create-account",
        component: () => import("@/views/service-provider/ServiceProviderCreateAccount"),
        meta: {
          authorize: [Role.ServiceProvider],
        },
      },


    ],
  },
];
